// extracted by mini-css-extract-plugin
export default {"user_icon":"user-icon_user_icon__UoxDA","initials":"user-icon_initials__n1uV2"};